import { inject, Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SwUpdate } from "@angular/service-worker";

@Injectable({
	providedIn: "root",
})
export class UpdateService {
	private swUpdate: SwUpdate = inject(SwUpdate);
	private snackbar: MatSnackBar = inject(MatSnackBar);

	constructor() {
		this.swUpdate.versionUpdates.subscribe((evt) => {
			// const snack = this.snackbar.open("Update Available", "Reload", {
			// 	duration: 12000,
			// });
			// snack.onAction().subscribe(() => {
			// 	window.location.reload();
			// });
			window.location.reload();
		});
		this.swUpdate.unrecoverable.subscribe((evt) => {
			// const snack = this.snackbar.open("Update Available", "Reload", {
			// 	duration: 12000,
			// });
			// snack.onAction().subscribe(() => {
			// 	window.location.reload();
			// });
			window.location.reload();
		});
		this.swUpdate.checkForUpdate();
	}
}
